export default __webpack_public_path__ + "static/media/capture.8bdbe4c1.png";